import { extractArrayFromQuery } from '../../../utils/query';

export default {
  param: extractArrayFromQuery,
  having: function (values) {
    if (values.length > 0) {
      return {
        $or: values.map(function(value) {
          const count = Number(value) - 1;

          if (count === 3) {
            return {
              numberOfPartnerInteractions: {
                $gte: count
              }
            }
          }

          return {
            numberOfPartnerInteractions: {
              $equals: count
            }
          };
        })
      }
    }
  }
}
